import { ChatMessageData } from '../chatMessages/types';

export type ChatRoom = {
  id: string;
  client_id: string;
  specialist_id: string;
  updated_at: number;
  type?: CHAT_ROOM_TYPES | null;
};

export interface ChatRoomsData {
  avatar: string;
  name: string;
  room: ChatRoom;
  last_message: ChatMessageData;
  is_blocked_chat?: boolean;
}

export interface ChatRooms {
  entities: ChatRoomsData[];
  limit: number;
  offset: number;
  isInfiniteDisabled: boolean;
  loading: 'idle' | 'pending' | 'succeeded' | 'failed';
  isFirstLoading: boolean;
}

export enum CHAT_ROOM_TYPES {
  'MINDLY_BROADCAST_ROOM' = 'MINDLY_BROADCAST_ROOM',
}
